/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import DropFilter from 'material/dropdowns/dropfilter/dropfilter';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/controlbar/controlbar_styles';



/* ========== ~~~~~~~~~~ CONTENT INDICATOR SORT  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ContentIndicatorSort = (props) => {
    return (
        <DropFilter name={'Embed State'} title={'All States'} button={`false`}
                    icon={`power-off`} onSelect={props.handleSelect} items={props.allStatus}
                    selectedItems={props.status}/>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentIndicatorSort);